/* CAMPAIGNS LIST DATA */
export const GET_CAMPAIGNS_LIST = "GET_CAMPAIGNS_LIST"
export const SET_CAMPAIGNS_LIST = "SET_CAMPAIGNS_LIST"

/* LOADER LIST */
export const SHOW_CAMPAIGNS_LIST_LOADER = "SHOW_CAMPAIGNS_LIST_LOADER"
export const HIDE_CAMPAIGNS_LIST_LOADER = "HIDE_CAMPAIGNS_LIST_LOADER"